import React from 'react';
import { SidebarLinkProps } from './types';
import { IconWrapper, LinkBackground, StyledLink, StyledTypography } from './sidebar-link.styles';
import { LINK_BG_CLASSNAME, LINK_TEXT_CLASSNAME } from './contants';

export const SidebarLink: React.FC<SidebarLinkProps> = ({ href, text, children }) => {
    return (
        <StyledLink to={href} activeClassName='active' exact>
            <LinkBackground className={LINK_BG_CLASSNAME} />
            <IconWrapper>{children}</IconWrapper>
            <StyledTypography size='subtitle2' className={LINK_TEXT_CLASSNAME}>
                {text}
            </StyledTypography>
        </StyledLink>
    );
};
